/**
 * Helpers for creating FolderSharing instance
 */

import type { IBaseNotary } from "../../BaseNotaryFactory";
import type { FolderSharing } from "le-coffre-resources/dist/Notary";
import {
	createShareFolderMethod,
	createGetSharedFoldersMethod,
	createGetFolderSharesMethod,
	createResendInvitationMethod,
	createRevokeShareMethod,
	createUpdateShareMethod,
	type ShareFolderParams,
	type FolderSharingShareResponse,
} from "./folderSharingMethodsHelpers";

export interface FolderSharingInstance {
	shareFolder(folderUid: string, params: ShareFolderParams): Promise<FolderSharingShareResponse>;
	getSharedFolders(): Promise<FolderSharing[]>;
	getFolderShares(folderUid: string): Promise<FolderSharing[]>;
	resendInvitation(folderUid: string, shareUid: string): Promise<void>;
	revokeShare(folderUid: string, shareUid: string): Promise<FolderSharing>;
	updateShare(
		folderUid: string,
		shareUid: string,
		invitedNotaryEmail: string,
		invitedNotaryIdnot?: string,
	): Promise<FolderSharing>;
}

/**
 * Create FolderSharing instance with all methods
 */
export function createFolderSharingInstance(baseNotary: IBaseNotary): FolderSharingInstance {
	const foldersUrl = baseNotary.namespaceUrl.concat("/folders");

	return {
		shareFolder: createShareFolderMethod(baseNotary, foldersUrl),
		getSharedFolders: createGetSharedFoldersMethod(baseNotary),
		getFolderShares: createGetFolderSharesMethod(baseNotary, foldersUrl),
		resendInvitation: createResendInvitationMethod(baseNotary, foldersUrl),
		revokeShare: createRevokeShareMethod(baseNotary, foldersUrl),
		updateShare: createUpdateShareMethod(baseNotary, foldersUrl),
	};
}
